import { useSelector } from 'react-redux';

function useMediaPoolItems() {
  const items = useSelector((state) => state.story.mediaPool);
  const isLoading = useSelector((state) => state.story.isMediaPoolLoading);
  const searchQuery = useSelector((state) => state.story.mediaPoolSearchQuery);
  const sourceMode = useSelector((state) => state.story.mediaPoolSourceMode);

  return {
    items,
    isLoading,
    isEmpty: items.length === 0,
    searchQuery,
    sourceMode,
  };
}

export default useMediaPoolItems;
